/**
 * Obiekt transferu danych (DTO) reprezentujący żądanie zwrotu środków (Refund).
 */
export class RefundDto {

  /** Globalnie unikalny identyfikator.
   */
  public uuid: string;

  /** Powód wykonania zwrotu.
   * Kluczowe pole z perspektywy audytu finansowego i analityki.
   */
  public reason: string;

  /** Typ operacji zwrotu.
   */
  public type: string;

  /** Kwota do zwrotu.
   * * Użycie typu `string` dla wartości finansowej zapobiega błędom
   * precyzji zmiennoprzecinkowej, zmuszając parser po stronie serwera
   * do bezpiecznego zrzutowania tej wartości na precyzyjne typy liczbowe.
   */
  public price: string;

}
